// Clockwise around the ring, starting at the top. `word` feeds the hero headline.
export const COACHES = [
  {
    name: 'Alexis',
    word: 'sleep',
    image: '/images/intro/coach_alexis.png',
    insight:
      'Every night you hit 10,000 steps, you fall asleep 22 minutes faster. Three nights last week. Make it four.',
  },
  {
    name: 'Ivy',
    word: 'stress',
    image: '/images/intro/coach_ivy.png',
    insight:
      "Busy days don't spike your stress. Nights under 6 hours do. Fix the night before and Tuesday gets easier.",
  },
  {
    name: 'Suky',
    word: 'weight',
    image: '/images/intro/coach_suky.png',
    insight:
      "Down 1.8kg in five weeks - and every week you logged breakfast, you lost weight. Skipped weeks, you didn't.",
  },
  {
    name: 'Jack',
    word: 'energy',
    image: '/images/intro/coach_jack.png',
    insight:
      "The 3pm slump isn't lunch. It only follows days under 1.5L of water. Two glasses before lunch, then we compare.",
  },
  {
    name: 'Aran',
    word: 'immunity',
    image: '/images/intro/coach_aran.png',
    insight:
      'You got ill both times sleep fell under 6 hours three nights running. Two nights in now - protect tonight.',
  },
  {
    name: 'Sofia',
    word: 'focus',
    image: '/images/intro/coach_sofia.png',
    insight:
      "Your best focus days follow 7+ hours' sleep and a morning walk - together. Either alone barely moves it.",
  },
];
